import { c } from "react-compiler-runtime";
import { useContext, createContext } from "react";
const TransportHookContext = createContext(null);
function useGraphiQLPluginContext() {
  const $ = c(11);
  const registry = useContext(TransportHookContext);
  if (registry === null) {
    let t02;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t02 = {};
      $[0] = t02;
    } else {
      t02 = $[0];
    }
    return t02;
  }
  let t0;
  if ($[1] !== registry) {
    t0 = registry.onBeforeSend.bind(registry);
    $[1] = registry;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== registry) {
    t1 = registry.onResponse.bind(registry);
    $[3] = registry;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== registry) {
    t2 = registry.onError.bind(registry);
    $[5] = registry;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      transport: {
        onBeforeSend: t0,
        onResponse: t1,
        onError: t2
      }
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export {
  TransportHookContext,
  useGraphiQLPluginContext
};
//# sourceMappingURL=transport-hooks.context.js.map
